import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Font, Head, Html, Container as ContainerBase } from "@react-email/components";
const containerStyle = {
    paddingRight: '20px',
    paddingLeft: '20px',
};
export default function Container({ children }) {
    return (_jsxs(Html, { children: [_jsx(Head, { children: _jsx(Font, { fontFamily: "Inter", fallbackFontFamily: "Arial", webFont: {
                        url: "https://fonts.gstatic.com/s/inter/v13/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7W0Q5nw.woff2",
                        format: "woff2",
                    }, fontWeight: '100 900', fontStyle: "normal" }) }), _jsx(ContainerBase, { style: containerStyle, children: children })] }));
}
